import { render, staticRenderFns } from "./common-audit.vue?vue&type=template&id=b7dc6ece&scoped=true"
import script from "./common-audit.vue?vue&type=script&lang=js"
export * from "./common-audit.vue?vue&type=script&lang=js"
import style0 from "./common-audit.vue?vue&type=style&index=0&id=b7dc6ece&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7dc6ece",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b7dc6ece')) {
      api.createRecord('b7dc6ece', component.options)
    } else {
      api.reload('b7dc6ece', component.options)
    }
    module.hot.accept("./common-audit.vue?vue&type=template&id=b7dc6ece&scoped=true", function () {
      api.rerender('b7dc6ece', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/common-audit.vue"
export default component.exports